import React from "react";

export function DocsIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M8 13.0534C6 11.5453 4 12.048 2 13.0534V4.00526C3.5 2.9999 5.5 2.49703 8 4.00517"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={vectorEffect}
      />
      <path
        d="M8 13.0534C10 11.5453 12 12.048 14 13.0534V4.00526C12.5 2.9999 10.5 2.49703 8 4.00517"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={vectorEffect}
      />
      <path
        d="M8 4V13"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={vectorEffect}
      />
    </svg>
  );
}
